import classnames from 'classnames';
import PropTypes from 'prop-types';

// app
import { DynamicTableComponent, TableCell } from 'components';
import * as utils from 'utils';
import styles from './DynamicTableRow.styles';

// mui
import { makeStyles, TableRow } from '@material-ui/core';

const restrictedInputs = ['0', '0%', 'n/a', 'na', '-'];
const displaySubRow = (value) => typeof value === 'string' && value.length > 0 && !restrictedInputs.includes(value.toLowerCase());

DynamicTableRowView.propTypes = {
  row: PropTypes.object.isRequired,
  formProps: PropTypes.object.isRequired,
};

export function DynamicTableRowView({ row, formProps }) {
  const classes = makeStyles(styles, { name: 'DynamicTableRow' })();
  const tableRowClasses = {
    [classes.subCell]: row.rowStyles && Boolean(row.rowStyles.subRow),
    [classes.subCellHeader]: row.rowStyles && Boolean(row.rowStyles.subRowHeader),
  };
  const { watch } = formProps;
  const changedByValue = watch(row.rowStyles.changeBy);
  const showRow = row.rowStyles.changeBy
    ? !row.rowStyles?.isHidden || displaySubRow(changedByValue)
    : !row.rowStyles?.isHidden;
  return (
    showRow && (
      <TableRow className={classnames(tableRowClasses)}>
        {row.cells.map((cell, index) => {
          return (
            <TableCell key={`${row.tabKey}-${row.rowKey}-${index}`} compact {...cell.cellProps}>
              {cell.label ? (
                <p
                  className={classnames({
                    [classes.labelIndent]: index === 0,
                    [classes.labelIndentExtra]: row.rowStyles?.extraLeftPadding,
                    [classes.labelWithComponent]: cell.type,
                  })}
                >
                  {utils.string.t(cell.label)}
                </p>
              ) : (
                ''
              )}
              {cell.type ? (
                <div className={classnames({ [classes.labelIndent]: index === 0 })}>
                  <DynamicTableComponent formProps={formProps} field={utils.form.getFieldProps(row.cells, cell.name)} rowKey={row.rowKey} />
                </div>
              ) : null}
            </TableCell>
          );
        })}
      </TableRow>
    )
  );
}
